import {useIntl} from "react-intl";
import React, {useState} from "react";
import Item from "./Item";
import {useOutletContext} from "react-router-dom";

export default function LineItems(
    {
        vatsOptions,
        total,
        setTotal,
        items,
        setItems = () => {
        },
    }
) {
    const intl = useIntl()
    const {context} = useOutletContext()
    const [loadingDelete, setLoadingDelete] = useState([])
    const setItem = (index, item, label, qty, price_includes_vat,  price, vat, vat_name, vat_percent) => {

        let newItems = [...items]
        vat_percent = parseFloat(vat_percent)
        price = parseFloat(price)
        newItems[index] = {...item}
        newItems[index].label = label
        newItems[index].qty = qty
        newItems[index].price = price
        newItems[index].price_includes_vat = price_includes_vat
        if (!price_includes_vat) {
            // Dacă prețul este fără TVA, TVA se va adăuga la total
            newItems[index].price = price
            newItems[index].price_with_vat = parseFloat(price * (1 + vat_percent / 100)).toFixed(2)
        } else {
            // Dacă prețul include TVA, îl scoatem din preț
            newItems[index].price = parseFloat(price / (1 + vat_percent / 100)).toFixed(2)
            newItems[index].price_with_vat = price
        }
        newItems[index].vat = vat
        newItems[index].vat_name = vat_name
        newItems[index].vat_percent = vat_percent

        let totalTemp = 0
        for (let i=0; i < newItems.length; i++){
            totalTemp += parseFloat(parseFloat(parseFloat(newItems[i].price) * parseFloat(newItems[i].qty)).toFixed(2))
        }

        setTotal(totalTemp)
        context.setContentUpdated(true)
        setItems(newItems)

    }
    const deleteItem = (item) => {
        let newItems = [...items]
        let index = newItems.indexOf(item)
        if (index > -1) {
            context.setContentUpdated(true)
            setTotal(parseFloat(total - item.qty * item.price))
            newItems.splice(index, 1);
            setItems(newItems)
        }
        setLoadingDelete([])
    }
    return (
        <table className={"invoice-table-container"}>
            <thead>
            <tr className={"heading"}>
                <th className={"description"}>{intl.formatMessage({id: 'invoices.description'})}</th>
                <th className={"quantity"}>{intl.formatMessage({id: 'general.qty'})}</th>
                <th className={"price"}>{intl.formatMessage({id: 'general.price'})}</th>
                <th className={"price"}>{intl.formatMessage({id: 'general.vat'})}</th>
                <th className={"subtotal right-aligned-cell"}>{intl.formatMessage({id: 'invoices.subtotal'})}</th>
                <th className={"delete"}></th>
            </tr>
            </thead>
            <tbody>
            {items && items.map((item, i) => (
                <Item
                    vatsOptions={vatsOptions}
                    key={item.label + i}
                    item={item}
                    setItem={(label, qty, price_includes_vat, price, vat, vat_name, vat_percent) => setItem(i, item, label, qty, price_includes_vat, price, vat, vat_name, vat_percent)}
                    disabledDelete={loadingDelete[i] ?? false}
                    onDelete={() => {
                        let load = []
                        load[i] = true
                        setLoadingDelete(load)
                        deleteItem(item)
                    }}
                />
            ))}
            </tbody>
        </table>
    );
}

